<template>
  <div class="container" :key="fullCode">
    <fullPage @leaveSlide="leaveSlide" :currentParent="fullIndex" ref="fullPage">
      <div slot="section" class="container">
        <activity-first :currentIndex="currentIndex"></activity-first>
      </div>
      <div slot="section" class="container">
        <activity-second :currentIndex="currentIndex"></activity-second>
      </div>
      <div slot="section" class="container">
        <activity-third :currentIndex="currentIndex"></activity-third>
      </div>
      <div slot="section" class="container">
        <activity-fourth :currentIndex="currentIndex"
                         @scrollListener="scrollListener"></activity-fourth>
      </div>
    </fullpage>
  </div>
</template>

<script>

  import activityFirst from '@/page/activity/components/ActivityFirst'
  import activitySecond from '@/page/activity/components/ActivitySecond'
  import activityThird from '@/page/activity/components/ActivityThird'
  import activityFourth from '@/page/activity/components/ActivityFourth'
  import fullPage from '@/components/fullPage'
  import merge from 'webpack-merge'
  export default {
    name: "Activity",
    data() {
      return {
        fullIndex: 0,
        fullCode: 0,
        currentIndex: 1,
        lastIndex: 2,
      }
    },

    components: {
      activityFirst,
      activitySecond,
      activityThird,
      activityFourth,
      fullPage,
    },

    mounted() {
      if (!this.$store.state.isPc) {
        this.$store.commit('isAlphaEdit', true)
      }
      this.fullIndex = parseInt(this.$route.query.index)
    },

    watch: {
      '$route': function (newUrl, oldUrl) {
        if (newUrl != oldUrl && this.$store.state.isSlide) {
          this.fullCode = parseInt(this.$route.query.index)
          this.fullIndex = parseInt(this.$route.query.index)
        }
      }
    },

    methods: {
      leaveSlide(item) {
        this.currentIndex = item.currentIndex
        this.lastIndex = item.currentIndex
        this.$router.push({
          query:merge(this.$route.query,{index:item.currentIndex})
        })
        this.$store.commit('slideEdit',false)
        this.$store.commit('edit',item.currentIndex - 1)
        if ( item.currentIndex == 4) {
          this.$refs.fullPage.api.setAllowScrolling(false)
        }
      },
      scrollListener(e) {
        this.$refs.fullPage.api.setAllowScrolling(true)
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/activity/Activity.vue